import { ModelFactory } from "@shared/factories/model.factory";
import { Officer } from "@modules/officer/models/officer.model";
import { OfficerType } from "@generated/graphql";

export class OfficerFactory extends ModelFactory<OfficerType, Officer> {
  create (state: OfficerType): Officer {
    return new Officer(state);
  }
}

export const officerFactory = new OfficerFactory()
